import React, { memo, useCallback, useMemo } from 'react'

import { TextInput, Slider } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, number, string, func, oneOfType } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

function PolyCountSlider({
  isDisabled = false,
  targetPolycount = 0,
  setTargetPolycount = NOOP,
  minimum = 0,
  maximum = 0,
}) {
  const handleChange = useCallback((value) => {
    setTargetPolycount(value)
  }, [])

  const handleInputChange = useCallback(
    (e) => {
      const value = e.target.value
      if (value === '') {
        setTargetPolycount(value)

        return
      }

      const numValue = parseInt(value, 10)
      if (!Number.isNaN(numValue) && numValue >= 0) {
        setTargetPolycount(numValue)
      }
    },
    []
  )

  const handleInputBlur = useCallback(() => {
    if (targetPolycount < minimum) {
      setTargetPolycount(minimum)
    }

    if (targetPolycount > maximum) {
      setTargetPolycount(maximum)
    }
  }, [targetPolycount, minimum, maximum])

  const sliderValue = useMemo(() => {
    if (!targetPolycount || targetPolycount < minimum) {
      return minimum
    }

    if (targetPolycount > maximum) {
      return maximum
    }

    return targetPolycount
  }, [targetPolycount, minimum, maximum])

  return (
    <div className="model-settings__row model-settings__row--polycount-slider">
      <Slider
        hideRangeValues
        max={maximum}
        min={minimum}
        step={500}
        onChange={handleChange}
        value={sliderValue}
        isDisabled={isDisabled}
        wrapperClassName="model-settings__polycount-slider"
      />
      <TextInput
        value={targetPolycount || ''}
        onChange={handleInputChange}
        size="small"
        id="custom-poly-count-input"
        isPilot
        textInputClassName="model-settings__polycount-input"
        onBlur={handleInputBlur}
        isDisabled={isDisabled}
      />
    </div>
  )
}

PolyCountSlider.propTypes = {
  isDisabled: bool,
  targetPolycount: oneOfType([number, string]),
  setTargetPolycount: func,
  minimum: number,
  maximum: number,
}

export default memo(PolyCountSlider)
